import angular from 'angular';
import { ITrabalhador } from '../../../models/trabalhador.model';

export class ModalRetornarDoAfastamentoService {
    static $inject = ['$uibModal'];

    constructor(private $uibModal: ng.ui.bootstrap.IModalService) { }

    public open(trabalhador: ITrabalhador) {
        return this.$uibModal.open({
            template: require('html-loader!./modalRetornarDoAfastamento.html'),
            controller: 'ModalRetornarDoAfastamentoController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            resolve: {
                entity: () => angular.copy(trabalhador)
            }
        });
    }
}
